module.exports = __webpack_public_path__ + "assets/3b14f23a233b45791e5cc1bb71bfa65c.ico";